export default __webpack_public_path__ + "static/media/medal.39435f23.svg";